<cl-warning
  *ngIf="(isDemonstrationCompany$ | async) ?? false"
  [type]="typeWarning"
  [text]="(warningTextIsDemo$ | async) ?? ''"
></cl-warning>
